import WithdrawalsPage from './WithdrawalsPage';

export default WithdrawalsPage;
